<template>
  <div class="questions">
    <div ref="question" v-for="(item, index) in questionList" :key="index" class="question">
      <div class="question-title" :id="`title${item.index}`" @click="handleIsFold(item)">
        <h4>
          <i v-if="item.tier < 3" :class="item.isFold ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"></i>
          <span v-if="item.index">{{ item.index }}.</span>
          {{ item.name }}（{{ item.score }}分）
        </h4>
      </div>
      <div :style="foldClass(item)" style="overflow: hidden">
        <!-- 自评情况 -->
        <el-form @submit.native.prevent ref="form" v-if="item.tier == 3" class="selfFrom" label-position="left" :model="item">
          <el-form-item label="自评分数：">{{ item.testScore }}分</el-form-item>
          <el-form-item label="自评描述：">
            <TextOverflow v-if="item.describe" :text="item.describe" :maxLines="2">
              <template v-slot:default="{ clickToggle, expanded }">
                <div @click.stop="clickToggle" class="btn_textOverflow blue">
                  {{ expanded ? '收起' : '展开全部>' }}
                </div>
              </template>
            </TextOverflow>
          </el-form-item>
          <el-form-item label="佐证图片：">
            <div class="suppBox">
              <div @click="handleViewer(item.picture, todex)" class="suppPicture" v-for="(pic, todex) in item.picture" :key="`${todex}a`">
                <img :src="pic" alt="" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="附件项：">
            <div v-if="item.selfAttachments && item.selfAttachments.length" style="display: table-caption">
              <el-button v-for="(file, f) in JSON.parse(item.selfAttachments)" :key="`${f}f`" type="text" @click.stop="handleFileViewing(file)">{{ file.name }}</el-button>
            </div>
          </el-form-item>
        </el-form>
        <!-- 评价规则 -->
        <template v-if="item.evaluationRuleList && item.evaluationRuleList.length">
          <div class="rule">
            <div class="rule-content">
              <el-collapse>
                <el-collapse-item>
                  <template slot="title"> <span style="width: 15px"></span>展开/折叠评价规则： </template>
                  <div class="rule-item" v-for="(rule, todex) in item.evaluationRuleList" :key="todex">
                    <span style="width: 15px"></span>分值<span class="blue"> {{ rule.score }}</span> 分：
                    <span style="flex: 0.9">{{ rule.name }}</span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </template>
        <!-- 专家填写内容区域 -->
        <el-form @submit.native.prevent ref="form" label-position="top" :model="item" v-if="item.tier == 4">
          <el-form-item label="专家评分" required>
            <el-input-number @change="changeinputExpertScore(item)" v-if="!isEdit" size="small" v-model="item.expertScore" :min="0" :controls="false"></el-input-number>
            <span v-else>{{ item.expertScore }}分</span>
          </el-form-item>
          <el-form-item label="亮点描述">
            <el-input size="small" v-if="!isEdit" type="textarea" autosize placeholder="请输入亮点描述" v-model="item.expertOpinion"> </el-input>
            <span v-else>{{ item.expertOpinion ?? '--' }}</span>
          </el-form-item>
          <el-form-item label="改善点描述">
            <el-input size="small" v-if="!isEdit" type="textarea" autosize placeholder="请输入改善点描述" v-model="item.pointDescription"> </el-input>
            <span v-else>{{ item.pointDescription ?? '--' }}</span>
          </el-form-item>
          <el-form-item label="改善点建议">
            <el-input size="small" v-if="!isEdit" type="textarea" autosize placeholder="请输入建议" v-model="item.suggest"> </el-input>
            <span v-else>{{ item.suggest ?? '--' }}</span>
          </el-form-item>
          <el-form-item label="佐证图片">
            <div class="suppBox">
              <div @click="handleViewer(item.expertPicture, todex)" class="suppPicture" v-for="(pic, todex) in item.expertPicture" :key="`${todex}a`">
                <img :src="pic" alt="" />
                <i v-if="!isEdit" @click.stop="handleDelPic(pic, item)" class="picDel el-icon-error"></i>
              </div>
              <el-upload
                accept="image/*"
                v-if="!isEdit"
                class="avatar-uploader suppPicture"
                :action="uploadUrl"
                :show-file-list="false"
                :http-request="(fileObj) => uploadImg(fileObj, item)">
                <div class="avatar" type="primary">+</div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="附件项">
            <div v-if="isEdit" style="display: table-caption">
              <el-button v-for="(file, f) in JSON.parse(item.expertAttachments)" :key="`${f}f`" type="text" @click.stop="handleFileViewing(file)">{{ file.name }}</el-button>
            </div>
            <uploadItem
              v-else
              :placeholder="'上传附件'"
              :filesList="item.expertAttachments && item.expertAttachments.length ? JSON.parse(item.expertAttachments) : []"
              :multiple="true"
              :otherOpts="true"
              :fileItem="item"
              :btnText="'上传附件'"
              @changeFile="updateFiles">
            </uploadItem>
          </el-form-item>
        </el-form>
        <questItem :isEdit="isEdit" v-if="item.questionBankList && item.questionBankList.length" :data="item.questionBankList"></questItem>
      </div>
    </div>
    <!-- 上传图片截图工具 -->
    <cropper ref="myCroppr" @emitt="callBack"></cropper>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
  </div>
</template>

<script>
import cropper from '../../../components/cropper.vue';
import TextOverflow from '../../../components/textOverflow.vue';
import PreviewFile from '../../../components/file-preview.vue';
import uploadItem from '../../../components/uploadItem.vue';
export default {
  name: 'questItem',
  components: { cropper, TextOverflow, PreviewFile, uploadItem },
  data() {
    return {
      questionList: [],
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
    };
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        this.questionList = newVal;
        if (this.questionList && this.questionList.length) {
          this.questionList.forEach((e) => {
            this.$set(e, 'isSue', true);
          });
        }
      },
      deep: true,
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.questionList = this.data;
    if (this.questionList && this.questionList.length) {
      this.questionList.forEach((e) => {
        this.$set(e, 'isSue', true);
      });
    }
  },

  mounted() {
    // 延迟调用，让递归组件加载完成
    setTimeout(() => {
      this.BoxLayout();
    }, 100);
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    BoxLayout() {
      this.$nextTick(() => {
        let lists = document.querySelectorAll('.suppBox');
        if (lists && lists.length) {
          lists.forEach((lis) => {
            const boxLay = new this.DynamicBoxLayout(lis, '.suppPicture', 80);
            boxLay.boxes.forEach((box) => {
              if (box) {
                box.style.height = box.style.width;
              }
            });
          });
        }
      });
    },
    uploadImg(fileObj, item) {
      this.$refs.myCroppr.changeUpload(fileObj, item);
    },
    // 图标上传回调
    callBack(data) {
      data.type.expertPicture.push(data.url);
      this.$message({ message: `上传成功`, type: 'success' });
      setTimeout(() => {
        this.BoxLayout();
      }, 100);
    },
    // 删除佐证图片
    handleDelPic(pic, item) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post('api/file/deleteFileByUrl', { fileUrl: pic }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: `删除成功`,
                type: 'success',
                offset: 80,
              });
              const index = item.expertPicture.indexOf(pic);
              if (index > -1) {
                item.expertPicture.splice(index, 1);
              }
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 80,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 查看佐证图片
    handleViewer(item, key) {
      this.$viewerApi({
        images: item,
        options: {
          initialViewIndex: key,
        },
      });
    },
    handleIsFold(item) {
      // 只有层级小于 3 的才能够折叠
      if (item.tier < 3) {
        item.isFold = !item.isFold;
      }
    },
    foldClass(item) {
      // 只有层级小于 3 的才能够折叠
      if (item.tier < 3) {
        return item.isFold ? 'height:0px' : 'height:auto';
      }
    },
    // 附件处理
    updateFiles(item, res2) {
      // 附件字段赋值
      let params = [];
      res2.forEach((e) => {
        let file = { name: e.name, url: e.response ? e.response.url : e.url };
        params.push(file);
      });
      this.$set(item, 'expertAttachments', JSON.stringify(params));
    },
    changeinputExpertScore(item) {
      if (item.expertScore > item.score) {
        this.$message({
          message: `填写分数不可大于该项分值`,
          type: 'error',
          offset: 80,
        });
        this.$nextTick(() => {
          item.expertScore = 0;
        });
      }
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
  },
};
</script>

<style lang="less" scoped>
.questions {
  // height: 100%;
  user-select: none;
  box-sizing: border-box;
  .question {
    padding-left: 16px;
    cursor: pointer;
    line-height: 28px;
    .question-title {
      position: relative;
      display: flex;
      align-items: center;
    }
    .rule {
      border-radius: 6px;
      margin: 8px 0;
      margin-right: 8px;
      background-color: rgba(80, 88, 105, 0.06);
      border: 1px solid rgba(80, 88, 105, 0.2);
      // padding: 8px 10px;
      color: rgba(80, 88, 105, 1);
      font-size: 14px;
      display: flex;
      flex-direction: column;
      .rule-content {
        color: rgba(80, 88, 105, 0.6);
        .blue {
          font-weight: 600;
        }
        .rule-item {
          display: flex;
          align-items: flex-start;
          margin: 6px 0;
        }
      }
    }
  }
}
.suppBox {
  display: flex;
  flex-wrap: wrap;
  .suppPicture {
    margin: 0 10px 10px 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .picDel {
      position: absolute;
      right: 4px;
      top: 4px;
      font-size: 22px;
      color: rgba(255, 0, 0, 0.735);
      cursor: pointer;
    }
  }
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 10px 10px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  /deep/ .el-upload {
    width: 100%;
    height: 100%;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    display: block;
    font-size: 38px;
    color: #d9d9d9;
  }
}

/deep/ .el-form-item__label {
  padding-bottom: 0;
}
/deep/ .el-form-item__content {
  line-height: normal !important;
}
/deep/ .el-form-item {
  margin-bottom: 1px;
  margin: 6px 0;
}
.selfFrom {
  /deep/ .el-form-item__label {
    color: rgba(80, 88, 105, 0.7);
    padding-bottom: 0;
  }
}

/deep/ .el-collapse {
  border-top: none;
  .el-collapse-item__header {
    border-bottom: none;
    height: 32px;
    line-height: 32px;
    background-color: rgba(80, 88, 105, 0.06);
    color: rgba(80, 88, 105, 0.6);
  }
  .el-collapse-item__wrap {
    background-color: rgba(80, 88, 105, 0.06);
    color: rgba(80, 88, 105, 0.6);
  }
  .el-collapse-item__content {
    color: rgba(80, 88, 105, 0.6);
  }
}
.btn_textOverflow {
  font-size: 12px;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .question {
    font-size: 13px;
    line-height: 16px;
  }
}
</style>
